import { createContext, useContext } from "react";
/**
 * Deployment state independent of the SDK being enabled: `ArtisAppProvider` provides it
 * whenever it is mounted, so version-update UI works for every user, not only those with
 * the artis API flag.
 */
export const DeploymentSourceContext = createContext(null);
/** The {@link DeploymentSource} from the nearest `ArtisAppProvider`, or `null` outside one. */
export const useDeploymentSource = () => useContext(DeploymentSourceContext);
//# sourceMappingURL=deploymentSource.js.map